import { format } from 'date-fns';
import ruLocale from 'date-fns/locale/ru';

const correctDate = (date: string): string => {
  const [day, month, year] = date.split('-');
  return `${year}-${month}-${day}`;
};

const parceMeeting = (data: any) => ({
  address: data!.place || '',
  date: {
    day:
      data.date && data.date.length ? format(correctDate(data.date), 'D') : '',
    month:
      data.date && data.date.length
        ? format(correctDate(data.date), 'MMMM', { locale: ruLocale })
        : '',
  },
  filled: data!.filled,
  format: data!.format || '',
  status: data!.status || '',
  time: data.time && data.time.length ? data.time.slice(0, 5) : '',
  type: data!.type || '',
});

export default parceMeeting;



// WEBPACK FOOTER //
// ./src/services/mentoring/utils/parceMeeting.ts